<template>
  <Breadcrumbs
      title="Create Distributor Staff"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Staff', path: '/distributor-staff' },
      { label: 'Create Distributor Staff', path: '/new-staff' }
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <newStaff/>
    </div>
  </div>
</template>

<script>
import newStaff from './new_staff_form.vue'
export default {
  name: 'indexList',
  components: {
    newStaff,
  },
}
</script>